import axios from 'axios';
import { message } from 'antd';
import { setForceLogout, setPasswordExpired } from '../actions/authentication';
import store from '../store/appStore';
const dispatch = store?.dispatch;

const apiProvider = axios.create({});

const PASSWORD_EXPIRED_REDIRECT = '/account?forceChangePassword=1';
const PASSWORD_EXPIRED_MESSAGE =
  'Password expired. Please change your password to continue.';

// BE contract (ISS-287931): the global exception filter nests every error body
// under an `error` key — `{ error: { message, errorCode } }` — so the expiry
// code lives at `response.data.error.errorCode`, NOT `response.data.errorCode`.
// Reading the shallow path silently never matches and the forced flow never fires.
// `any`: axios rejection values are untyped here, matching the interceptor's own
// `(error)` param; optional chaining keeps every access null-safe.
export const isPasswordExpiredError = (error: any): boolean =>
  error?.response?.status === 403 &&
  error?.response?.data?.error?.errorCode === 'EUSS008';

// Add 401 interceptor
apiProvider.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    if (error && error.response && error.response.status === 401) {
      // Dispatch action that user is being force logged out
      await dispatch(setForceLogout());
      console.error('401, unauthenticated');
    } else if (isPasswordExpiredError(error)) {
      // Password expired — kick the user into the forced change-password screen.
      // Idempotent: only act once per expiry event so parallel failing requests
      // don't trigger duplicate toasts or redirect loops.
      const state = store?.getState();
      if (!state?.logoutReducer?.passwordExpired) {
        message.error(PASSWORD_EXPIRED_MESSAGE);
        await dispatch(setPasswordExpired());
        window.location.assign(PASSWORD_EXPIRED_REDIRECT);
      }
    } else if (error?.response?.status === 403) {
      if (!localStorage.getItem('organisationId')) {
        await dispatch(setForceLogout());
        console.error('403, Organisation Id not found');
      }
    }

    return Promise.reject(error);
  }
);

export default apiProvider;
